import { UtilService } from 'src/app/util/UtilService';
import { OperatingSystemType } from './../../../constant/device.constant';
import { PageConstant } from './../../../constant/page.constant';
import { SpriteConstant } from 'src/app/constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class SelectSettingsLayoutComponent implements OnInit {
  @Input() data: any;
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();
  isMac = '';

  lang_icons: any;
  common_icons: any;
  menu_icons: any;

  version = '';
  /*public optionImage: Object = {
    image_0: 'option_unselect',
    image_1: 'option_select',
  };*/
  public isView = true;
  constructor(public utilService: UtilService) {
    this.isMac =
      this.utilService.getOSType() !== OperatingSystemType.MAC ? '' : 'mac';
    this.menu_icons = SpriteConstant.MENU_ICONS;
    this.common_icons = SpriteConstant.COMMON_ICONS;
  }

  ngOnInit() {
    this.lang_icons = SpriteConstant.LANG_ICONS(this.data.currentLanguage);
    this.version = PageConstant.VERSION;
  }

  buttonOverOrOut(value) {
    this.isView = !this.isView;
    //console.log(value);
  }

  buttonClick(event) {
    //console.log(' this.isview ', this.isView);
    this.eventEmit.next('settings_hint_' + this.isView);
  }

  onAboutUsClick(event) {
    this.eventEmit.next('info_new_openFullColorGames');
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit('close');
  };
}
